import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import dsteem from "../unit/DsteemUtil";
import { getAccount, extractLoginData } from "../unit/UserUtil";
import { joinAutoClaimRewards, joinAutoFollowClubVote } from "../unit/boylikegirlcluboperUtil";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { joinToolData } from "../apis/services/steemActivity";
import { $t } from "../plugins/i18n";
export default {
  props: ["game"],
  name: "social-traffic-table",
  data: function data() {
    return {
      dialogVisible: false,
      isHavePermission: false,
      isUseKeychain: false,
      isloadEnd: false,
      acitveKey: "",
      isError: false,
      errorMessage: "",
      isLoading: false,
      //isJoined: false,
      isLoadJoinAutoClaimReward: false,
      data: {}
    };
  },
  methods: {
    authorize: function authorize() {
      this.dialogVisible = true;
    },
    confirmAuthorize: function confirmAuthorize() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.isLoading = true;
                _context.next = 4;
                return dsteem.accountAuthorizePost(_this.acitveKey, _this.game.username);

              case 4:
                result = _context.sent;
                _this.isLoading = false;

                if (!(result.code != 0)) {
                  _context.next = 10;
                  break;
                }

                _this.isError = true;
                _this.errorMessage = result.message;
                return _context.abrupt("return");

              case 10:
                _this.isHavePermission = true;
                _this.dialogVisible = false;
                ElMessage({
                  message: _this.$t("success.authorizeSuccess"),
                  type: "success"
                });
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                _this.isError = true;
                _this.errorMessage = _context.t0.message;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }))();
    },
    join: function join(joinItem) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var checkAuth, arrayindex, i, len, account, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loginData = extractLoginData();

                if (_this2.loginData) {
                  _context2.next = 5;
                  break;
                }

                _this2.isLogining = false;

                _this2.$bus.emit("openLogin");

                return _context2.abrupt("return");

              case 5:
                _this2.currentUserName = _this2.loginData[0];
                _this2.isUseKeychain = _this2.loginData[4] == "true";
                _context2.next = 9;
                return getAccount(_this2.currentUserName);

              case 9:
                _this2.account = _context2.sent;
                checkAuth = _this2.account.posting.account_auths;
                arrayindex = -1;

                if (!(_this2.currentUserName == _this2.game.username)) {
                  _context2.next = 16;
                  break;
                }

                _this2.isHavePermission = true;
                _context2.next = 25;
                break;

              case 16:
                i = 0, len = checkAuth.length;

              case 17:
                if (!(i < len)) {
                  _context2.next = 25;
                  break;
                }

                if (!(checkAuth[i][0] == _this2.game.username)) {
                  _context2.next = 22;
                  break;
                }

                arrayindex = i;
                _this2.isHavePermission = true;
                return _context2.abrupt("break", 25);

              case 22:
                i++;
                _context2.next = 17;
                break;

              case 25:
                if (!_this2.loginData) {
                  _context2.next = 48;
                  break;
                }

                account = _this2.loginData[0];
                _this2.isLoadJoinAutoClaimReward = true;
                _context2.prev = 28;
                _context2.t0 = joinItem;
                _context2.next = _context2.t0 === "isAutoClaimReward" ? 32 : _context2.t0 === "isAutoFollowClubVote" ? 36 : 40;
                break;

              case 32:
                _context2.next = 34;
                return joinAutoClaimRewards(account);

              case 34:
                result = _context2.sent;
                return _context2.abrupt("break", 40);

              case 36:
                _context2.next = 38;
                return joinAutoFollowClubVote(account);

              case 38:
                result = _context2.sent;
                return _context2.abrupt("break", 40);

              case 40:
                if (result.code == 0) {
                  ElMessage({
                    message: _this2.$t("success.joinSuccess"),
                    type: "success",
                    duration: 5000
                  });

                  if (_this2.data == null) {
                    _this2.data = {};
                  }

                  _this2.data[joinItem] = true;
                  /*   if (joinItem in this.data) {
                    this.data[joinItem] = true;
                  } else {
                    Object.defineProperty(this.data, joinItem, {
                      value: true,
                      enumerable: false,
                    });
                  } */

                  _this2.isLoadJoinAutoClaimReward = false;
                }

                _context2.next = 48;
                break;

              case 43:
                _context2.prev = 43;
                _context2.t1 = _context2["catch"](28);
                debugger;
                ElMessage.error(_context2.t1);
                _this2.isLoadJoinAutoClaimReward = false;

              case 48:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[28, 43]]);
      }))();
    },
    goTo: function goTo(url) {
      console.log("goTo", url);
      window.open(url, "_blank");
    },
    isJoined: function isJoined(joinItem) {
      if (this.data != null) return this.data[joinItem];else return false;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var checkAuth, arrayindex, i, len, input, result;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this3.game.joinType == 1)) {
                _context3.next = 30;
                break;
              }

              _this3.loginData = extractLoginData();

              if (!_this3.loginData) {
                _context3.next = 29;
                break;
              }

              _this3.currentUserName = _this3.loginData[0];
              _this3.isUseKeychain = _this3.loginData[4] == "true";
              _context3.next = 7;
              return getAccount(_this3.currentUserName);

            case 7:
              _this3.account = _context3.sent;
              checkAuth = _this3.account.posting.account_auths;
              arrayindex = -1;

              if (!(_this3.currentUserName == _this3.game.username)) {
                _context3.next = 14;
                break;
              }

              _this3.isHavePermission = true;
              _context3.next = 23;
              break;

            case 14:
              i = 0, len = checkAuth.length;

            case 15:
              if (!(i < len)) {
                _context3.next = 23;
                break;
              }

              if (!(checkAuth[i][0] == _this3.game.username)) {
                _context3.next = 20;
                break;
              }

              arrayindex = i;
              _this3.isHavePermission = true;
              return _context3.abrupt("break", 23);

            case 20:
              i++;
              _context3.next = 15;
              break;

            case 23:
              input = {};
              input.data = _this3.currentUserName;
              _context3.next = 27;
              return joinToolData(input);

            case 27:
              result = _context3.sent;

              if (result.code == 0) {
                _this3.data = result.data;
              }

            case 29:
              _this3.isloadEnd = true;

            case 30:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};